// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BotSelector
   Pinned in the sidebar directly under the OrgSwitcher. Geometry mirrors
   \`.org-switcher\` exactly so the two selectors line up (same 90% width,
   same 14px scrollbar gutter, same trigger padding + chevron). */

.bot-selector {
  position: relative;
  width: 100%;
  margin: 0 0 12px 0;
  padding-right: 14px;
  box-sizing: border-box;
}

.bot-selector-trigger {
  display: flex;
  align-items: center;
  width: 90%;
  margin: 0 auto;
  background: transparent;
  border: 1px solid #bdbdbd;
  border-radius: 8px;
  color: #f8f8f8;
  box-sizing: border-box;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.bot-selector-trigger:hover,
.bot-selector-trigger:focus-within,
.bot-selector-trigger.open {
  background-color: var(--sidebar-hover-bg);
  border-color: #ffffff;
}

.bot-selector-label {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
  padding: 8px 4px 8px 12px;
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}

.bot-selector-chev-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px 8px 4px;
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  flex-shrink: 0;
}

.bot-selector-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: none;
  color: #fff;
  flex: 0 0 28px;
  font-size: 18px;
}

.bot-selector-text {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.bot-selector-name {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bot-selector-role {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.65);
  margin-top: 1px;
}

.bot-selector-chev {
  color: #ffffff;
  transition: transform 0.25s ease;
  flex: 0 0 auto;
}

/* Dropdown ----------------------------------------------------------- */
.bot-selector-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 5%;
  right: calc(5% + 14px);
  background: #fff;
  color: #222;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18), 0 1px 4px rgba(0, 0, 0, 0.12);
  z-index: 1300;
  overflow: hidden;
  padding: 6px 0;
  max-height: 360px;
  overflow-y: auto;
}

.bot-selector-menu-header {
  padding: 6px 12px 4px 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #888;
}

.bot-selector-empty {
  padding: 10px 12px;
  font-size: 13px;
  color: #888;
}

.bot-selector-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 12px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  color: #222;
  font-size: 13px;
  font-family: inherit;
  transition: background 0.12s ease;
}

.bot-selector-item:hover:not(:disabled) {
  background: #f4f1fe;
}

.bot-selector-item.current {
  background: #f7f4ff;
}

.bot-selector-item.action {
  color: #5616ea;
  font-weight: 500;
}

.bot-selector-item-check {
  width: 16px;
  display: inline-flex;
  justify-content: center;
  color: #5616ea;
  font-size: 12px;
  flex-shrink: 0;
}

.bot-selector-item-text {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.bot-selector-item-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bot-selector-divider {
  height: 1px;
  background: #eee;
  margin: 6px 0;
}

/* ── Header variant (light bar, compact single-line trigger) ───────── */
.bot-selector.header {
  width: auto;
  margin: 0;
  padding-right: 0;
  min-width: 0;
}

.bot-selector.header .bot-selector-trigger {
  width: auto;
  margin: 0;
  max-width: 220px;
  background-color: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.16);
  color: #ffffff;
}

.bot-selector.header .bot-selector-trigger:hover,
.bot-selector.header .bot-selector-trigger:focus-within,
.bot-selector.header .bot-selector-trigger.open {
  background-color: rgba(255, 255, 255, 0.16);
  border-color: rgba(255, 255, 255, 0.28);
}

.bot-selector.header .bot-selector-label {
  padding: 6px 4px 6px 10px;
  gap: 8px;
}

.bot-selector.header .bot-selector-chev-btn {
  padding: 6px 10px 6px 4px;
}

.bot-selector.header .bot-selector-icon {
  width: auto;
  height: auto;
  font-size: 14px;
  color: #ffffff;
  flex: 0 0 auto;
}

.bot-selector.header .bot-selector-role {
  display: none;
}

.bot-selector.header .bot-selector-name {
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
}

.bot-selector.header .bot-selector-chev {
  color: rgba(255, 255, 255, 0.8);
}

.bot-selector.header .bot-selector-menu {
  left: 0;
  right: auto;
  min-width: 240px;
}
`, "",{"version":3,"sources":["webpack://./src/components/BotSelector.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,8DAA8D;AAChE;;AAEA;;;EAGE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yEAAyE;EACzE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,2CAA2C;EAC3C,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;;;EAGE,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,OAAO;EACP,WAAW;EACX,gBAAgB;AAClB","sourcesContent":["/* BotSelector\r\n   Pinned in the sidebar directly under the OrgSwitcher. Geometry mirrors\r\n   `.org-switcher` exactly so the two selectors line up (same 90% width,\r\n   same 14px scrollbar gutter, same trigger padding + chevron). */\r\n\r\n.bot-selector {\r\n  position: relative;\r\n  width: 100%;\r\n  margin: 0 0 12px 0;\r\n  padding-right: 14px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.bot-selector-trigger {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 90%;\r\n  margin: 0 auto;\r\n  background: transparent;\r\n  border: 1px solid #bdbdbd;\r\n  border-radius: 8px;\r\n  color: #f8f8f8;\r\n  box-sizing: border-box;\r\n  transition: background-color 0.2s ease, border-color 0.2s ease;\r\n}\r\n\r\n.bot-selector-trigger:hover,\r\n.bot-selector-trigger:focus-within,\r\n.bot-selector-trigger.open {\r\n  background-color: var(--sidebar-hover-bg);\r\n  border-color: #ffffff;\r\n}\r\n\r\n.bot-selector-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex: 1;\r\n  min-width: 0;\r\n  padding: 8px 4px 8px 12px;\r\n  background: transparent;\r\n  border: none;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  font-family: inherit;\r\n}\r\n\r\n.bot-selector-chev-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 8px 12px 8px 4px;\r\n  background: transparent;\r\n  border: none;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.bot-selector-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 28px;\r\n  height: 28px;\r\n  background: transparent;\r\n  border: none;\r\n  color: #fff;\r\n  flex: 0 0 28px;\r\n  font-size: 18px;\r\n}\r\n\r\n.bot-selector-text {\r\n  flex: 1 1 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n}\r\n\r\n.bot-selector-name {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #fff;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.bot-selector-role {\r\n  font-size: 11px;\r\n  color: rgba(255, 255, 255, 0.65);\r\n  margin-top: 1px;\r\n}\r\n\r\n.bot-selector-chev {\r\n  color: #ffffff;\r\n  transition: transform 0.25s ease;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n/* Dropdown ----------------------------------------------------------- */\r\n.bot-selector-menu {\r\n  position: absolute;\r\n  top: calc(100% + 6px);\r\n  left: 5%;\r\n  right: calc(5% + 14px);\r\n  background: #fff;\r\n  color: #222;\r\n  border-radius: 8px;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18), 0 1px 4px rgba(0, 0, 0, 0.12);\r\n  z-index: 1300;\r\n  overflow: hidden;\r\n  padding: 6px 0;\r\n  max-height: 360px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.bot-selector-menu-header {\r\n  padding: 6px 12px 4px 12px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.4px;\r\n  text-transform: uppercase;\r\n  color: #888;\r\n}\r\n\r\n.bot-selector-empty {\r\n  padding: 10px 12px;\r\n  font-size: 13px;\r\n  color: #888;\r\n}\r\n\r\n.bot-selector-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  color: #222;\r\n  font-size: 13px;\r\n  font-family: inherit;\r\n  transition: background 0.12s ease;\r\n}\r\n\r\n.bot-selector-item:hover:not(:disabled) {\r\n  background: #f4f1fe;\r\n}\r\n\r\n.bot-selector-item.current {\r\n  background: #f7f4ff;\r\n}\r\n\r\n.bot-selector-item.action {\r\n  color: #5616ea;\r\n  font-weight: 500;\r\n}\r\n\r\n.bot-selector-item-check {\r\n  width: 16px;\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  color: #5616ea;\r\n  font-size: 12px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.bot-selector-item-text {\r\n  flex: 1 1 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n}\r\n\r\n.bot-selector-item-name {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.bot-selector-divider {\r\n  height: 1px;\r\n  background: #eee;\r\n  margin: 6px 0;\r\n}\r\n\r\n/* ── Header variant (light bar, compact single-line trigger) ───────── */\r\n.bot-selector.header {\r\n  width: auto;\r\n  margin: 0;\r\n  padding-right: 0;\r\n  min-width: 0;\r\n}\r\n\r\n.bot-selector.header .bot-selector-trigger {\r\n  width: auto;\r\n  margin: 0;\r\n  max-width: 220px;\r\n  background-color: rgba(255, 255, 255, 0.07);\r\n  border: 1px solid rgba(255, 255, 255, 0.16);\r\n  color: #ffffff;\r\n}\r\n\r\n.bot-selector.header .bot-selector-trigger:hover,\r\n.bot-selector.header .bot-selector-trigger:focus-within,\r\n.bot-selector.header .bot-selector-trigger.open {\r\n  background-color: rgba(255, 255, 255, 0.16);\r\n  border-color: rgba(255, 255, 255, 0.28);\r\n}\r\n\r\n.bot-selector.header .bot-selector-label {\r\n  padding: 6px 4px 6px 10px;\r\n  gap: 8px;\r\n}\r\n\r\n.bot-selector.header .bot-selector-chev-btn {\r\n  padding: 6px 10px 6px 4px;\r\n}\r\n\r\n.bot-selector.header .bot-selector-icon {\r\n  width: auto;\r\n  height: auto;\r\n  font-size: 14px;\r\n  color: #ffffff;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.bot-selector.header .bot-selector-role {\r\n  display: none;\r\n}\r\n\r\n.bot-selector.header .bot-selector-name {\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.bot-selector.header .bot-selector-chev {\r\n  color: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n.bot-selector.header .bot-selector-menu {\r\n  left: 0;\r\n  right: auto;\r\n  min-width: 240px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
